import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import Select from 'react-select';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Switzerland() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Switzerland') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [access, setAccess] = useState('');

    const accessOptions = [
        {
            value: "Take place on the next possible regular termination date. The contract provisions should be adhered to so that no charges relating to breach of contract are incurred when the contract for the telephone line is terminated.",
            label: "Take place on the next possible regular termination date. The contract provisions should be adhered to so that no charges relating to breach of contract are incurred when the contract for the telephone line is terminated."
        },
        {
            value: "My desired date for the termination is as soon as possible or on: …………………… If this date is prior to expiry of the notice period or minimum contract term for the telephone line, I agree to pay in full any charges relating to breach of contract billed to me by my previous provider.",
            label: "My desired date for the termination is as soon as possible or on: …………………… If this date is prior to expiry of the notice period or minimum contract term for the telephone line, I agree to pay in full any charges relating to breach of contract billed to me by my previous provider."
        }
    ];

    const customStyles = {
        control: (base, state) => ({
            ...base,
            border: '2px solid rgb(166, 162, 162)',
            borderRadius: '0px',
            height: '38px',
            fontSize: '16px',
            fontFamily: 'inherit',
            backgroundColor: '#fff',
            boxShadow: 'none',
            padding: '0 4px',
            '&:hover': {
                borderColor: '#888'
            }
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '0 8px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center'
        }),
        singleValue: (base) => ({
            ...base,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0
        }),
        option: (base, state) => ({
            ...base,
            whiteSpace: 'normal',
            fontSize: '14px',
            backgroundColor: state.isFocused ? '#eee' : '#fff',
            color: '#000',
            padding: '10px'
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999
        }),
        dropdownIndicator: (base) => ({
            ...base,
            padding: '6px',
            color: '#333'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        })
    };

    const [company, setCompany] = useState();
    const [street, setStreet] = useState();
    const [postcode, setPostcode] = useState();
    const [town, setTown] = useState();
    const [preProv, setPreProv] = useState();

    const [checkBox, setCheckBox] = useState(false);
    const [checkBox2, setCheckBox2] = useState(false);

    const [mainNum, setMainNum] = useState();

    const [pra, setPra] = useState("");

    const [terminationDate, setTerminationDate] = useState('');
    const [terminationTime, setTerminationTime] = useState('');

    const [authContact, setAuthContact] = useState();
    const [date, setDate] = useState();

    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 1); // Enforces tomorrow+

    // const getFormattedDate = (dateObj) => {
    //     return dateObj.toISOString().split('T')[0];
    // };

    // const handleChangeDate = (e) => {
    //     const selectedDate = new Date(e.target.value);
    //     const today = new Date();
    //     today.setHours(0, 0, 0, 0); // Normalize

    //     const minAllowedDate = new Date(today);
    //     minAllowedDate.setDate(minAllowedDate.getDate() + 15); // Block 14 days

    //     if (selectedDate < minAllowedDate) {
    //         toast.error("Please select a date after 2 weeks from today.");
    //         setDate("");
    //         return;
    //     }

    //     setDate(e.target.value);
    // };

    const [place, setPlace] = useState();

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        document.querySelector('#company').value = form?.country?.client?.company ?? '';
        document.querySelector('#street').value = form?.country?.client?.street ?? '';
        document.querySelector('#postcode').value = form?.country?.client?.postcode ?? '';
        document.querySelector('#town').value = form?.country?.client?.town ?? '';
        document.querySelector('#preProv').value = form?.country?.client?.preProv ?? '';
        setCompany(form?.country?.client?.company ?? '');
        setStreet(form?.country?.client?.street ?? '');
        setPostcode(form?.country?.client?.postcode ?? '');
        setTown(form?.country?.client?.town ?? '');
        setPreProv(form?.country?.client?.preProv ?? '');

        document.querySelector('#mainNum').value = form?.country?.numberDetails?.mainNum ?? '';
        document.querySelector('#checkBox').value = form?.country?.numberDetails?.checkBox ?? '';
        document.querySelector('#checkBox2').value = form?.country?.numberDetails?.checkBox2 ?? '';

        setAccess(form?.country?.numberDetails?.access ?? '');

        // Delay setting termination values to allow conditional fields to render
        setTimeout(() => {
            const desired = form?.country?.numberDetails?.access?.includes("desired");
            if (desired) {
                setTerminationDate(form?.country?.numberDetails?.terminationDate ?? '');
                setTerminationTime(form?.country?.numberDetails?.terminationTime ?? '');
            } else {
                setTerminationDate('');
                setTerminationTime('');
            }
        }, 0); // Minimal delay to ensure React has re-rendered the fields

        setMainNum(form?.country?.numberDetails?.mainNum ?? '');
        setCheckBox(form?.country?.numberDetails?.checkBox ?? '');
        setCheckBox2(form?.country?.numberDetails?.checkBox2 ?? '');
        setTableData(form?.country?.numberDetails?.Number ?? []);
        setTableDataSingle(form?.country?.numberDetails?.Single_Number ?? []);
        setTableDataRange(form?.country?.numberDetails?.Number_Range ?? []);

        document.querySelector('#pra').value = form?.country?.numberDetails?.pra ?? '';
        setPra(form?.country?.numberDetails?.pra ?? '');


        document.querySelector('#authContact').value = form?.country?.contactDetails?.authContact ?? '';
        document.querySelector('#date').value = form?.country?.contactDetails?.date ?? '';
        document.querySelector('#place').value = form?.country?.contactDetails?.place ?? '';
        setAuthContact(form?.country?.contactDetails?.authContact ?? '');
        setDate(form?.country?.contactDetails?.date ?? '');
        setPlace(form?.country?.contactDetails?.place ?? '');

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (Net Service Number / Rufnummer)--------------------------------------//

    const [tableData, setTableData] = useState([{ id: Date.now(), netNum: '' }]);

    //adding a row
    const addRow = () => {
        setTableData([...tableData, { id: Date.now(), netNum: '' }]);
    };

    //removing a row
    const removeRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_table = (id, key, value) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableData(updatedData);
    };

    //--------------------------------table declaration (Single)--------------------------------------//

    const [tableDataSingle, setTableDataSingle] = useState([{ id: Date.now(), num: '' }]);

    //adding a row
    const addRow_single = () => {
        setTableDataSingle([...tableDataSingle, { id: Date.now(), num: '' }]);
    };

    //removing a row
    const removeRow_single = (id) => {
        setTableDataSingle(tableDataSingle.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableSingle = (id, key, value) => {
        const updatedData = tableDataSingle.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataSingle(updatedData);
    };

    //--------------------------------table declaration (Number Range)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Display the file name
        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange (first two columns: start & end number)
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '', // First column (start number)
                eNumber: row[1] ? row[1].toString() : '', // Second column (end number)
            }));

            // Set the table data for number range
            setTableDataRange(formattedDataRange);

            // Trigger validation for each row after setting data (similar to previous logic)
            formattedDataRange.forEach(row => {
                const startValue = row.sNumber;
                const endValue = row.eNumber;

                // Validate rangeStart (10-11 digits)
                if (startValue !== '' && !/^\d{10,11}$/.test(startValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: true,
                    }));
                }

                // Validate rangeStop (10-11 digits)
                if (endValue !== '' && !/^\d{10,11}$/.test(endValue)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: false,
                    }));
                } else {
                    setValidationStates(prev => ({
                        ...prev,
                        [`endNumber-${row.id}`]: true,
                    }));
                }

                // Check if end range is greater than or equal to start range
                if (startValue && endValue && parseInt(endValue, 10) < parseInt(startValue, 10)) {
                    setValidationStates(prev => ({
                        ...prev,
                        [`startNumber-${row.id}`]: false,
                        [`endNumber-${row.id}`]: false,
                    }));
                }

            });
        };
        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        // Clear the uploaded file name state
        setUploadedFileName('');

        // Reset the file input field value to clear the selected file
        fileInputRef.current.value = '';

        // Clear the table data by setting it to an empty array
        setTableDataRange([]);

        // Optionally clear the table data for 'Number Range' table
        setTableDataRange([]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Switzerland",
            "client": {
                "company": company,
                "street": street,
                "postcode": postcode,
                "town": town,
                "preProv": preProv
            },
            "numberDetails": {
                "checkBox": checkBox,
                "Number": tableData,
                "checkBox2": checkBox2,
                "Single_Number": tableDataSingle,
                "mainNum": mainNum,
                "Number_Range": tableDataRange,
                "pra": pra,
                "access": access,
                "terminationDate": terminationDate,
                "terminationTime": terminationTime
            },

            "contactDetails": {
                "authContact": authContact,
                "date": date,
                "place": place
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        if (!company) {
            validationErrors.company = 'Please fill in Company Name';
        }
        if (!street) {
            validationErrors.street = 'Please fill in Street';
        }
        if (!postcode) {
            validationErrors.postcode = 'Please fill in Post Code';
        }
        if (!town) {
            validationErrors.town = 'Please fill in Town';
        }

        if (checkBox) {
            const emptyRows = tableData.filter(row => (row.netNum || '').trim() === '');

            if (emptyRows.length > 0) {
                emptyRows.forEach(row => {
                    const key = `netNumber-${row.id}`;
                    validationErrors[key] = 'This field is required.';
                });
            }
        }

        if (!access) {
            validationErrors.access = 'Please specify access.';
        } else if (access.includes('desired')) {
            if (!terminationDate) {
                validationErrors.terminationDate = 'Please specify a termination date.';
            }
            if (!terminationTime) {
                validationErrors.terminationTime = 'Please specify a termination time.';
            }
        }

        if (!authContact) {
            validationErrors.authContact = 'please fill in Authorized Contact for the company';
        }
        if (!place) {
            validationErrors.place = 'please fill in Place';
        }
        if (!date) {
            validationErrors.date = 'please fill in Date';
        }

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = company + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p>

                    <p>I would like to change my telecom service provider and keeping the number(s)</p> <br></br>

                    <h2 className='heading'>Client information</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('company')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Company*</label> <br />
                            <input
                                onChange={(e) => setCompany(e.target.value)}
                                type="text"
                                id="company"
                                placeholder=""
                                className={`inputbox ${validationStates.company === false ? 'error' : ''}`}
                                onBlur={() => validateInput('company', /^[\w\W,]+$/)}

                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('street')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Street*</label> <br />
                            <input
                                onChange={(e) => setStreet(e.target.value)}
                                type="text"
                                id="street"
                                placeholder=""
                                className={`inputbox ${validationStates.street === false ? 'error' : ''}`}
                                onBlur={() => validateInput('street', /^[\w\W,]+$/)}

                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('postcode')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Post Code*</label> <br />
                            <input
                                onChange={(e) => setPostcode(e.target.value)}
                                type="text"
                                id="postcode"
                                placeholder=""
                                className={`inputbox ${validationStates.postcode === false ? 'error' : ''}`}
                                onBlur={() => validateInput('postcode', /^\d{4}$/)}

                            />
                            {hoveredField === 'postcode' && (
                                <div className="hover-description">
                                    Post code must be 4 digits.
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('town')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Town*</label> <br />
                            <input
                                onChange={(e) => setTown(e.target.value)}
                                type="text"
                                id="town"
                                placeholder=""
                                className={`inputbox ${validationStates.town === false ? 'error' : ''}`}
                                onBlur={() => validateInput('town', /^[\w\W,]+$/)}

                            />
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('preProv')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Previous Provider</label> <br />
                            <input
                                onChange={(e) => setPreProv(e.target.value)}
                                type="text"
                                id="preProv"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Number details</h2> <br></br>

                    <p>I hereby authorise ORANGE BUSINESS SWITZERLAND AG, Beethovenstrasse 48, 8002 Zurich
                        to arrange the transfer of the below mentioned Number from my previous provider.</p> <br></br>

                    <Row>
                        <Col>
                            <div>
                                <input
                                    type="checkbox"
                                    id="checkBox"
                                    name="checkBox"
                                    checked={checkBox}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        setCheckBox(isChecked);

                                        // Reset validation if unchecked
                                        if (!isChecked) {
                                            const resetStates = {};
                                            tableData.forEach(row => {
                                                resetStates[`netNumber-${row.id}`] = true;
                                            });
                                            setValidationStates(prev => ({
                                                ...prev,
                                                ...resetStates
                                            }));
                                        }
                                    }}
                                />
                                <label htmlFor="mainline">&nbsp;the transfer of below mentioned Number from my previous provider and to use it for new services</label>
                            </div>
                        </Col>
                    </Row>

                    <br></br>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Net Service Number / Rufnummer</th>
                            </tr>
                        </thead>
                        <tbody>

                            {tableData.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`netNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >

                                        <input
                                            type="text"
                                            id={`netNumber-${row.id}`}
                                            value={row.netNum}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_table(row.id, 'netNum', value);

                                                // Only check for non-empty if checkbox is checked
                                                if (checkBox && value.trim() === '') {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`netNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`netNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            onBlur={() => {
                                                // Same non-empty check on blur
                                                if (checkBox && row.netNum.trim() === '') {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`netNumber-${row.id}`]: false,
                                                    }));
                                                    toast.error('This field is required.');
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`netNumber-${row.id}`] === false ? 'error' : ''}`}
                                        />
                                        {validationStates[`netNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                This field is required.
                                            </div>
                                        )}

                                        {hoveredField === `netNumber-${row.id}` && (
                                            <div className="hover-description">
                                                Add here any toll free or shared cost number.
                                            </div>
                                        )}

                                    </td>

                                    <td>
                                        {tableData.length > 1 && (
                                            <button onClick={() => removeRow(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow}>Add Row</button>

                </Container>

                <br></br><br></br>

                <Container>
                    <h2 className='heading'>ONP Nummer porting </h2> <br></br>

                    <Row>
                        <Col>
                            <div>
                                <input
                                    type="checkbox"
                                    id="checkBox2"
                                    name="checkBox2"
                                    checked={checkBox2} // Bind state to checked attribute
                                    onChange={(e) => setCheckBox2(e.target.checked)} // Handle checkbox change
                                />
                                <label htmlFor="mainline">&nbsp;to arrange the transfer of the number(s) listed below from my previous provider</label>
                            </div>
                        </Col>
                    </Row>

                    <br></br>

                    <h4 className='text-decoration-underline'>Single Numbers</h4> <br></br>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number</th>
                            </tr>
                        </thead>
                        <tbody>

                            {tableDataSingle.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`number-${row.id}`}
                                            value={row.num}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableSingle(row.id, 'num', value);

                                                // Immediate validation feedback for 10 to 11 digits only when not empty
                                                if (value !== '' && !/^\d{10,11}$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`number-${row.id}`] === false && row.num !== '' ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 10 to 11 digits only when not empty
                                                if (row.num !== '' && !/^\d{10,11}$/.test(row.num)) {
                                                    toast.error('Number must be between 10 and 11 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `number-${row.id}` && (
                                            <div className="hover-description">
                                                including the area code (e.g. 021/345 67 67)
                                            </div>
                                        )}
                                        {validationStates[`number-${row.id}`] === false && row.num !== '' && (
                                            <div className="error-message">
                                                Number must be between 10 and 11 digits.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataSingle.length > 1 && (
                                            <button onClick={() => removeRow_single(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_single}>Add Row</button>

                    <br></br> <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('mainNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Main Number</label> <br />
                            <input
                                type="text"
                                id="mainNum"
                                placeholder=""
                                value={mainNum}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    // Update the state with the input value
                                    setMainNum(value);

                                    // Immediate validation feedback for 10 to 11 digits
                                    if (value && !/^\d{10,11}$/.test(value)) { // Allow between 10 and 11 digits
                                        setValidationStates(prev => ({
                                            ...prev,
                                            mainNum: false,
                                        }));
                                    } else {
                                        setValidationStates(prev => ({
                                            ...prev,
                                            mainNum: true,
                                        }));
                                    }
                                }}
                                className={`inputbox ${validationStates.mainNum === false ? 'error' : ''}`}
                                onBlur={() => {
                                    // Final validation check on blur for 10 to 11 digits
                                    if (mainNum && !/^\d{10,11}$/.test(mainNum)) { // Only validate if value is not empty
                                        toast.error('Main Number must be between 10 and 11 digits.');
                                        setValidationStates(prev => ({
                                            ...prev,
                                            mainNum: false,
                                        }));
                                    }
                                }}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <h4 className='text-decoration-underline'>Number Range</h4> <br></br>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number range start</th>
                                <th>Number range end</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`} // Corrected ID for num input
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                // Immediate validation feedback for 10 to 11 digits
                                                if (value && !/^\d{10,11}$/.test(value)) { // Allow between 10 and 11 digits
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 10 to 11 digits
                                                if (row.sNumber && !/^\d{10,11}$/.test(row.sNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be between 10 and 11 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                including the area code (e.g.021/345 67 67)
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && row.sNumber !== '' && (
                                            <div className="error-message">
                                                Number must be between 10 and 11 digits.
                                            </div>
                                        )}
                                    </td>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`} // Corrected ID for num input
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                // Immediate validation feedback for 10 to 11 digits
                                                if (value && !/^\d{10,11}$/.test(value)) { // Allow between 10 and 11 digits
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                // Final validation check on blur for 10 to 11 digits
                                                if (row.eNumber && !/^\d{10,11}$/.test(row.eNumber)) { // Only validate if value is not empty
                                                    toast.error('Number must be between 10 and 11 digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                including the area code (e.g. 021/345 67 67)
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && row.eNumber !== '' && (
                                            <div className="error-message">
                                                Number must be between 10 and 11 digits.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br>

                    <Row>

                        <Col onMouseEnter={() => handleMouseEnter("pra")} onMouseLeave={handleMouseLeave}>
                            <label>PRA</label> <br />
                            <select name="pra" id="pra" value={pra} onChange={(e) => setPra(e.target.value)} className="inputbox">
                                <option value=""></option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </Col>

                    </Row>

                    <br></br>

                    <Row>
                        <Col onMouseEnter={() => handleMouseEnter("access")} onMouseLeave={handleMouseLeave}>
                            <label>
                                Cancellation of the access line contract from my previous provider should*
                            </label>
                            <br />
                            <Select
                                options={accessOptions}
                                value={accessOptions.find(opt => opt.value === access) || null}
                                onChange={(selectedOption) => {
                                    const value = selectedOption.value;
                                    setAccess(value);
                                    document.getElementById('access').value = value;

                                    // Re-validate immediately on change
                                    validateInput('access', /^[\w\W,]+$/);

                                    if (!value.includes("desired")) {
                                        setTerminationDate('');
                                        setTerminationTime('');
                                    }
                                }}
                                onBlur={() => validateInput('access', /^[\w\W,]+$/)}
                                className={`react-select ${validationStates.access === false ? 'error' : ''}`}
                                classNamePrefix="react-select"
                                styles={customStyles}
                                isSearchable={false}
                                id='access'
                            />

                            <input type="hidden" id="access" value={access} />
                        </Col>

                        <br></br> <br></br><br></br>

                        {access.includes("desired") && (
                            <Row className="mt-2">
                                <Col md={6} onMouseEnter={() => handleMouseEnter("terminationDate")} onMouseLeave={handleMouseLeave}>
                                    <label htmlFor="terminationDate">Desired Termination Date:</label>
                                    <input
                                        type="date"
                                        id="terminationDate"
                                        className={`inputbox ${validationStates.terminationDate === false ? 'error' : ''}`}
                                        value={terminationDate}
                                        onChange={(e) => setTerminationDate(e.target.value)}
                                        onBlur={() => validateInput('terminationDate', /^.+$/)}
                                    />
                                    {validationStates.terminationDate === false && (
                                        <span className="error-message">Please specify a termination date.</span>
                                    )}
                                    {hoveredField === 'terminationDate' && (
                                        <div className="hover-description">
                                            It can be changed later.
                                        </div>
                                    )}
                                </Col>

                                <Col md={6} onMouseEnter={() => handleMouseEnter("terminationTime")} onMouseLeave={handleMouseLeave}>
                                    <label htmlFor="terminationTime">Desired Termination Time:</label>
                                    <input
                                        type="time"
                                        id="terminationTime"
                                        className={`inputbox ${validationStates.terminationTime === false ? 'error' : ''}`}
                                        value={terminationTime}
                                        onChange={(e) => setTerminationTime(e.target.value)}
                                        onBlur={() => validateInput('terminationTime', /^.+$/)}
                                    />
                                    {validationStates.terminationTime === false && (
                                        <span className="error-message">Please specify a termination time.</span>
                                    )}
                                    {hoveredField === 'terminationTime' && (
                                        <div className="hover-description">
                                            It can be changed later.
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        )}

                    </Row>

                </Container>

                <br></br><br></br>

                <Container>

                    <p><strong>Please note:</strong> If I obtain services that require a contract for the telephone line, these shall be automatically terminated on the deactivation date (e.g. Internet access, Voice over IP, subscribed discounts). This can mean that my previous provider may bill additional charges relating to breach of contract. In order to avoid such additional costs, I must personally <strong>terminate</strong> all supplementary contracts (apart from the contract for the telephone line) on time, i.e. complying with the relevant deadlines and <strong>no later than the deactivation date for the telephone line.</strong></p> <br />

                    <h2 className='heading'>Contact details</h2> <br></br>

                    <p>Exact time and date of the transfer will be avices to me speratly at a later date from ORANGE BUSINESS SWITZERLAND AG . The provision of the service by the previous provider will end at this point in time.</p>

                    <p className='heading'><strong>If a joint signature exists, please provide two authorized signatures otherwise the LOA document will be rejected</strong></p>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('authContact')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Authorized contact for the company*</label> <br />
                            <input
                                onChange={(e) => setAuthContact(e.target.value)}
                                type="text"
                                id="authContact"
                                placeholder=""
                                className={`inputbox ${validationStates.authContact === false ? 'error' : ''}`}
                                onBlur={() => validateInput('authContact', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'authContact' && (
                                <div className="hover-description">
                                    If a joint signature exists, please provide the name in BLOCK captials.
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date*</label> <br />
                            {/* <input
                                onChange={handleChangeDate}
                                type="date"
                                id="date"
                                value={date}
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                                //min={getFormattedDate(minDate)} // Optional browser min (blocks past & today)
                            /> */}

                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id="date"
                                value={date}
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => { validateInput('date', /^.*$/); }}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />

                            {hoveredField === "date" && (
                                <div className="hover-description">
                                    Enter the portability date (must be 15 or more days from today)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('place')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Place*</label> <br />
                            <input
                                onChange={(e) => setPlace(e.target.value)}
                                type="text"
                                id="place"
                                placeholder=""
                                className={`inputbox ${validationStates.place === false ? 'error' : ''}`}
                                onBlur={() => validateInput('place', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'place' && (
                                <div className="hover-description">
                                    The place it was signed
                                </div>
                            )}
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Switzerland;